import React from 'react'
import { observer } from '~/common/mobx.decorator'
import { Box, Hidden, Popover } from '@material-ui/core'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { ContainerBox, logoutBoxStyle } from './user-account.style'
import { UserAvatar } from '~/components/user-avatar/user-avatar.component'
import { Typography } from '../typography'
import { ExitToAppOutlined } from '@material-ui/icons'
import { careStore } from '~/companies/care/care.store'
import { logClickEvent } from '~/common/tracking/event-client.tracking'
import { COMMON_EVENT_CLICK_TRACKING } from '~/common/constants/tracking.constant'

export const UserAccount = observer(({ ...props }) => {
	const { t } = useTranslation()
	const [anchorEl, setAnchorEl] = React.useState(null)

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
		logClickEvent(COMMON_EVENT_CLICK_TRACKING.profileBtn)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const open = Boolean(anchorEl)

	const { workerBasicInfo } = careStore

	return (
		<Hidden smDown>
			<ContainerBox {...props}>
				<>
					<div className="user-name-btn" onClick={handleClick}>
						<UserAvatar firstName={workerBasicInfo?.firstName} lastName={workerBasicInfo?.lastName} className="user-avatar-acc" />
						<Typography className="user-info">{[workerBasicInfo?.firstName, workerBasicInfo?.lastName].join(' ')}</Typography>
					</div>
					<Popover
						open={open}
						anchorEl={anchorEl}
						onClose={handleClose}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'right',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'right',
						}}
					>
						<Box css={logoutBoxStyle} onClick={() => careStore.logout()}>
							<ExitToAppOutlined />
							<Typography>{t('SIGN_OUT')}</Typography>
						</Box>
					</Popover>
				</>
			</ContainerBox>
		</Hidden>
	)
})
